(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var openDropdown = null;

    function closeDropdown(dropdown) {
      if (!dropdown) return;
      dropdown.classList.remove('is-open');
      var trigger = dropdown.querySelector('[data-gf-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      dropdown.querySelectorAll('[data-gf-option]').forEach(function (opt) {
        opt.classList.remove('is-active');
      });
      if (openDropdown === dropdown) openDropdown = null;
    }

    function openDropdownEl(dropdown) {
      if (!dropdown) return;
      if (openDropdown && openDropdown !== dropdown) closeDropdown(openDropdown);
      dropdown.classList.add('is-open');
      var trigger = dropdown.querySelector('[data-gf-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      var selected = dropdown.querySelector('[data-gf-option].is-selected');
      if (selected) {
        selected.classList.add('is-active');
        var menu = dropdown.querySelector('[data-gf-menu]');
        if (menu) {
          var offset = selected.offsetTop - menu.clientHeight / 2 + selected.clientHeight / 2;
          menu.scrollTop = Math.max(0, offset);
        }
      }
      openDropdown = dropdown;
    }

    function selectOption(dropdown, option) {
      if (!dropdown || !option) return;

      dropdown.querySelectorAll('[data-gf-option]').forEach(function (opt) {
        opt.classList.remove('is-selected');
        opt.setAttribute('aria-selected', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-selected', 'true');

      var valueEl = dropdown.querySelector('[data-gf-value]');
      var labelEl = option.querySelector('.gf-dropdown__option-label');
      if (valueEl && labelEl) valueEl.textContent = labelEl.textContent.trim();

      var nativeSelect = dropdown.querySelector('select');
      if (nativeSelect) {
        var key = option.dataset.key || '';
        var matched = false;
        Array.prototype.forEach.call(nativeSelect.options, function (o) {
          if (o.dataset && o.dataset.key === key && !matched) {
            o.selected = true;
            matched = true;
          } else {
            o.selected = false;
          }
        });
        var evt;
        try {
          evt = new Event('change', { bubbles: true });
        } catch (e) {
          evt = document.createEvent('Event');
          evt.initEvent('change', true, true);
        }
        nativeSelect.dispatchEvent(evt);
      }
    }

    function setupDropdown(dropdown) {
      var trigger = dropdown.querySelector('[data-gf-trigger]');
      var options = dropdown.querySelectorAll('[data-gf-option]');

      if (!trigger) return;

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (dropdown.classList.contains('is-open')) {
          closeDropdown(dropdown);
        } else {
          openDropdownEl(dropdown);
        }
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openDropdownEl(dropdown);
        }
      });

      options.forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.stopPropagation();
          selectOption(dropdown, option);
          closeDropdown(dropdown);
          if (trigger) trigger.focus();
        });

        option.addEventListener('mouseenter', function () {
          dropdown.querySelectorAll('[data-gf-option]').forEach(function (opt) {
            opt.classList.remove('is-active');
          });
          option.classList.add('is-active');
        });
      });

      dropdown.addEventListener('keydown', function (e) {
        if (!dropdown.classList.contains('is-open')) return;

        var optsArr = Array.prototype.slice.call(dropdown.querySelectorAll('[data-gf-option]'));
        var activeIdx = optsArr.findIndex(function (o) { return o.classList.contains('is-active'); });

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          var next = optsArr[(activeIdx + 1) % optsArr.length];
          optsArr.forEach(function (o) { o.classList.remove('is-active'); });
          if (next) {
            next.classList.add('is-active');
            next.scrollIntoView({ block: 'nearest' });
          }
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          var prevIdx = activeIdx <= 0 ? optsArr.length - 1 : activeIdx - 1;
          var prev = optsArr[prevIdx];
          optsArr.forEach(function (o) { o.classList.remove('is-active'); });
          if (prev) {
            prev.classList.add('is-active');
            prev.scrollIntoView({ block: 'nearest' });
          }
        } else if (e.key === 'Enter') {
          e.preventDefault();
          var current = optsArr[activeIdx];
          if (current) {
            selectOption(dropdown, current);
            closeDropdown(dropdown);
            if (trigger) trigger.focus();
          }
        } else if (e.key === 'Escape') {
          e.preventDefault();
          closeDropdown(dropdown);
          if (trigger) trigger.focus();
        } else if (e.key === 'Tab') {
          closeDropdown(dropdown);
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (openDropdown && !openDropdown.contains(e.target)) {
        closeDropdown(openDropdown);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openDropdown) {
        closeDropdown(openDropdown);
      }
    });

    document.querySelectorAll('[data-gf-dropdown]').forEach(setupDropdown);

    // ---- Form submission: build tag-filter URL ----
    document.querySelectorAll('[data-gift-finder-form]').forEach(function (form) {
      var occasionSelect = form.querySelector('[data-gift-finder-occasion]');
      var giftTypeSelect = form.querySelector('[data-gift-finder-gift-type]');
      var submitBtn = form.querySelector('[data-gift-finder-submit]');

      function buildTagFilterUrl(tags) {
        // tags = array of non-empty tag handles to intersect
        var clean = tags.filter(Boolean);
        if (clean.length === 0) return '/collections/all';
        var params = clean
          .map(function (t) { return 'filter.p.tag=' + encodeURIComponent(t); })
          .join('&');
        return '/collections/all?' + params;
      }

      function findUrl() {
        var occasionOpt = occasionSelect && occasionSelect.options[occasionSelect.selectedIndex];
        var giftTypeOpt = giftTypeSelect && giftTypeSelect.options[giftTypeSelect.selectedIndex];

        var occasionKey = occasionOpt ? (occasionOpt.dataset.key || '') : '';
        var giftTypeKey = giftTypeOpt ? (giftTypeOpt.dataset.key || '') : '';

        return buildTagFilterUrl([occasionKey, giftTypeKey]);
      }

      function handleSubmit(e) {
        if (e) e.preventDefault();
        var url = findUrl();
        if (url) window.location.href = url;
      }

      form.addEventListener('submit', handleSubmit);
      if (submitBtn) submitBtn.addEventListener('click', handleSubmit);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
